<template>
  <div class="c-global-header__container">
    <div class="c-global-header__placeholder j-global-header__placeholder-height" />
    <div class="c-global-header j-global-header-height">
      <div
        v-if="hasBannerSlot"
        class="c-global-header__banner t-heading-6 j-header__banner-height"
      >
        <slot name="banner" />
      </div>
      <div
        class="c-global-header__menu l-grid j-header__menu-height"
        :class="{'l-container':!isMobile}"
      >
        <DesktopNav
          v-if="!isMobile"
          ref="j-header__desktop-nav"
          :is-mobile="isMobile"
          :open-id="openId"
          :main-nav="mainNav"
        />
        <MobileNav
          v-if="isMobile"
          ref="j-header__mobile-nav"
          :is-mobile="isMobile"
          :open-id="openId"
          :main-nav="mainNav"
          :footer-nav="footerNav"
          :find-your-ring="findYourRing"
        >
          <slot
            v-for="(_, name) in $slots"
            :slot="name"
            :name="name"
          />
        </MobileNav>
        <div class="u-text-align-center">
          <nuxt-link to="/">
            <img
              v-if="image"
              class="c-global-header__logo"
              :src="image.src"
              :alt="image.alt"
            >
          </nuxt-link>
        </div>
        <UtilityNav
          class="u-text-align-right"
          :main-nav="mainNav"
          :is-mobile="isMobile"
          :find-your-ring="findYourRing"
        >
          <slot
            v-for="(_, name) in $slots"
            :slot="name"
            :name="name"
          />
        </UtilityNav>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from "./MobileNav";
import DesktopNav from "./DesktopNav";
import UtilityNav from "./UtilityNav";

export default {
  name: "GlobalHeader",
  components: {DesktopNav, MobileNav, UtilityNav},
  props: {
    mainNav: {
      type: Array,
      default: () => []
    },
    image:{
      type: Object,
      default: () => ({}),
    },
    footerNav: {
      type: Object,
      default: () => ({})
    },
    findYourRing: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      breakPoint: 1200,
      winWidth: 0,
      isMobile: false,
      showMobile: false,
      navItemComponents: [],
      openId: null,
    };
  },
  computed:{
    hasBannerSlot(){
      return !!this.$slots.banner;
    }
  },
  watch:{
    winWidth(){
      this.isMobile = this.winWidth <= this.breakPoint;
      this.findHeight();
      this.adjustIndicator();
    },
    isMobile(){
      this.$nextTick(() => {
        if(this.openId !== null){
          if(this.isMobile){
            this.showMobile = true;
          }
          if(this.$refs["j-header__item_" + this.openId]){
            this.$refs["j-header__item_" + this.openId][0].showSubMenu();
          }
        }
      });
    },
  },
  mounted(){
    this.$nextTick(() => {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
    this.findHeight();
    //double check the height through loading
    setTimeout(this.findHeight, 20);
    setTimeout(this.findHeight, 40);
    setTimeout(this.findHeight, 60);
    setTimeout(this.findHeight, 500);
    setTimeout(this.findHeight, 1000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  methods: {
    getWindowWidth() {
      this.winWidth = document.documentElement.clientWidth;
    },
    closeOtherMenus(notThisId = null){
      this.openId = notThisId;
    },
    clearOpen(id){
      if(this.openId === id){
        this.openId = null;
      }
    },
    findHeight(){
      this.$nextTick(() => {
        if (this.$el) {
          let topEl = this.$el.getElementsByClassName("j-global-header__placeholder-height")[0];

          let top = 0;

          let menuEl = document.getElementsByClassName("j-global-header-height").length > 0 ?
            document.getElementsByClassName("j-global-header-height")[0] : null;
          top += menuEl ? menuEl.getBoundingClientRect().height : 0;

          topEl.style.height = top + "px";
        }
      });
    },
    adjustIndicator(){
      if(this.$refs["j-header__desktop-nav"]){
        this.$refs["j-header__desktop-nav"].positionIndicator();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-global-header{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: $zindex-global-header;
    @include themify($themes){
      background-color: themed("background");
      border-bottom: $border themed("background", "x-light");
    }

    &__banner{
      @include themify($themes){
        color: themed("foreground", "white-text");
        background-color: themed("primary");
      }
      &-item{
        @include themify($themes){
          color: themed("foreground", "white-text");
        }
        display: block;
        padding: rem(8px) 0 rem(9px);
        text-align: center;
        & p {
          display: none;
        }
        & .t-paragraph {
          display: none;
        }
      }
      a:hover{
        @include themify($themes) {
          color: themed("accent");
        }
      }
    }

    &__menu{
      padding: $filter-padding;
      grid-template-columns: 45% 10% 45%;
      @include respond("tab-land"){
        grid-template-columns: 27% 39% 27%;
      }
    }

    &__logo{
      width: rem(120px);
    }
  }
</style>
